<template>
  <div>
    <LoadingPage />
    <AccountModal
      ref="accountModal"
      :accountList="accountList"
      @userSelect="userSelect"
      @hide="hide"
    />
    <FirstLoginModal ref="firstLoginModal" @submit="submit" @hide="hide" />
  </div>
</template>

<script>

import { createSetCookie, parseCookie } from '@/utils/cookie'
import { sendLoginEvent } from "@/utils/ga4";

export default {
  data() {
    return {
      verifier: undefined,
      challenge: undefined,
      backUri: undefined,
      contractList: [],
      selectContractModal: false,
      confirmContractModal: false,
      idToken: undefined,
      userInfo: {
        contract: null,
        isCompleteFirstLogin: undefined
      },
      currentHref: '/',
      accountList: [],
      subscriptions: [],
      companyCd: undefined,
    }
  },
  async created() {
    const cookie = parseCookie(document.cookie)
    // 有効期限の違いがあるため別途記述
    if (!cookie['back_uri']) {
      document.cookie = createSetCookie('back_uri', this.$route.query.authorization_back_uri)
    } else {
      this.backUri = cookie['back_uri'].replace(/^.*back_uri=/, '')
    }
  },
  async mounted() {
    //ssoチェック用のパラメタ
    let ssocheck=this.$route.query.ssocheck;
    // 不要なものは非表示に
    this.$page.isHeader = false
    this.$page.isPageTop = false
    this.$page.isBreadcrumb = false
    this.$page.isPageHeader = false
    this.$page.showFooterMenu = false
    const boCode = this.$store.getters["params/get"].boCode || 'CR';
    const companyCd = this.$store.getters["params/get"].companyCd
    this.$repositories('user')
      .contractInfo(boCode,companyCd)
      .then((resLogin) => {
        const errorPatternCode = resLogin?.data?.errorPatternCode;
        const errorCode = resLogin?.data?.errorCode;
        const startDate = resLogin?.data?.startDate;

        if (errorPatternCode) {
          this.handleErrorPattern(errorPatternCode, errorCode, startDate);
          return;
        }

        const contractInfo = resLogin.data.contractInfo
        const contractInfoLen = contractInfo.length

        // customerNoの数で処理を変更
        if (contractInfoLen > 1 || ssocheck==='select') {
          for (let i = 0; i < contractInfoLen; i++) {
            this.accountList.push({
              id: contractInfo[i].customerNo,
              name: contractInfo[i].companyName
            })
          }
          this.$refs.accountModal.show()
        } else {
          this.userConfirm(contractInfo[0].customerNo)
          this.subscriptions = contractInfo[0].subscriptions
          this.companyCd = contractInfo[0].companyCd
          this.boSrvCd = contractInfo[0].subscriptions[0].boServiceCode
        }
      }).catch((err) => {
        console.log(err)
        console.log('BFF:loginエラー')
        // ↓↓#71711 CRM独自対応として追加(start)↓↓
        // errにisErrorが含まれているかどうかを確認
        if (err.isError) {
          console.log(err.isError);
          const message = err.data.error.message;
          const jsonString = message.match(/\{.*\}/)[0];
          const parsedError = JSON.parse(jsonString);
          // エラーコードを取得
          const errorCode = parsedError.error;
          if (errorCode === "E-0001") {
            this.contractErrorLogin();
            return;
          }
        // errにdataが含まれているかどうかを確認
        } else if (err.data) {
          console.log(err.data);
          // エラーコードを取得
          const message = err.data.message;
          if (message === "E-0001") {
            this.contractErrorLogin();
            return;
          }
        }
        // ↑↑#71711 CRM独自対応として追加(end)↑↑
        this.erroLogin()
      })
  },
  beforeDestroy() {
    // 不要としたものを表示状態にする
    this.$page.isHeader = true
    this.$page.isPageTop = true
    this.$page.isBreadcrumb = true
    this.$page.isPageHeader = true
    this.$page.showFooterMenu = true
  },
  methods: {

    async userConfirm(customerNo) {
      this.$loading.show()
      const params = new FormData()
      params.append('customerNo', customerNo)
      /*
      const params = {
        customerNo: customerNo
      }
      */
    const boCode = this.$store.getters["params/get"].boCode || 'CR';
      const updateUserResult = await this.$repositories('user').updateUser(params,boCode)
      if (updateUserResult.isError) {
        console.log('BFF:ユーザー情報更新エラー', updateUserResult)
        this.erroLogin()
        return
      }

      if (updateUserResult.data.isCompleteFirstLogin) {
        // ユーザー情報取得
    const boCode = this.$store.getters["params/get"].boCode || 'CR';
        const postUserResult = await this.$repositories('user').postUser(boCode)
        if (postUserResult.isError) {
          console.log('/v1/users/my: エラー', postUserResult)
          this.erroLogin()
          return
        }
        const ssoCustomerNo = postUserResult.data.ssoCustomerNo;
        // CRM独自対応
        // window.dataLayer.push({
        //   event: "braze_login",
        //   customerNo: ssoCustomerNo,
        // });

        // #75846 契約情報を取得しユーザー情報に追加
        let contractInfo = []
        try {
          const response = await this.$repositories('user').contractInfo()
          contractInfo = response.data?.contractInfo || []
        } catch (err) {
          console.log('contractInfo取得エラー', err)
        }
        postUserResult.data.contract = contractInfo.find(contract => contract.customerNo === ssoCustomerNo) || {}

        this.finishLogin(postUserResult.data)
      } else {
        // 初回モーダル表示
        this.$refs.firstLoginModal.show()
        this.$loading.hide()
      }
    },
    async userSelect(customerNo) {
      await this.userConfirm(customerNo)
    },
    async submit(e) {
      this.$loading.show()
      const params = {
        isSubscribe: e.isSubscribe
      }

      // 初回ログイン完了API実行
      const putCompleteResult = await this.$repositories('login').putComplete(
        params
      )
      if (putCompleteResult.isError) {
        console.log('初回ログイン完了エラー', putCompleteResult)
        this.erroLogin()
        return
      }

      // ユーザー情報取得
      const boCode = this.$store.getters["params/get"].boCode || 'CR';
      const postUserResult = await this.$repositories('user').postUser(boCode)
      if (postUserResult.isError) {
        console.log('/v1/users/my：エラー')
        this.erroLogin()
        return
      }

      const ssoCustomerNo = postUserResult.data.ssoCustomerNo;
      // CRM独自対応
      // window.dataLayer.push({
      //   event: "braze_login",
      //   customerNo: ssoCustomerNo,
      // });

      // #75846 契約情報を取得しユーザー情報に追加
      let contractInfo = []
      try {
        const response = await this.$repositories('user').contractInfo()
        contractInfo = response.data?.contractInfo || []
      } catch (err) {
        console.log('contractInfo取得エラー', err)
      }
      const contractData = contractInfo.find(contract => contract.customerNo === ssoCustomerNo) || {}
      postUserResult.data.contract = contractData
      this.companyCd = contractData.companyCd
      this.finishLogin(postUserResult.data)
    },
    // ログイン関係でエラーが発生した場合の共通処理
    erroLogin() {
      this.deleteLoginCookie()
      // 戻り先用のクッキー削除
      document.cookie = createSetCookie('back_uri', '', new Date(0))
      // エラー画面へ遷移
      this.$router.push('error')
    },
    // ↓↓#71711 CRM独自対応として追加(start)↓↓
    // 契約が取得できない場合の共通処理
    contractErrorLogin() {
      this.deleteLoginCookie()
      // 認証処理で生成されたJSESSIONIDを削除
      document.cookie = createSetCookie(process.env.VUE_APP_SSO_COOKIE_NAME, "", new Date(0));
      // 戻り先用のクッキー削除
      document.cookie = createSetCookie("back_uri", "", new Date(0));
      // エラー画面へ遷移
      this.$router.push({ name: "contractError" });
    },
    // ↑↑#71711 CRM独自対応として追加(end)↑↑
    // ログインが完了した場合の共通処理
    async finishLogin(data) {
      // パラメータ(?以降のパス)がある場合はそのURLを指定
      if (this.$route.query.redirectURI != null) {
        console.log("SSOリダイレクト");
        this.$loading.hide()
        this.gotoBackURI(this.$route.query.redirectURI)
      } else {
        // 戻り先用のクッキー削除
        document.cookie = createSetCookie('back_uri', '', new Date(0))

        this.$auth.init(data, this.subscriptions)
        sessionStorage.setItem("companyCd", this.companyCd);
        const ssoCustomerNo = data?.ssoCustomerNo;
        // WebView判定（アプリなら "送信だけ" しない）
        const isWebView = typeof window !== "undefined" && !!window.ReactNativeWebView;
        // WebView判定（アプリなら送らない）
        if (!isWebView && ssoCustomerNo) {
          sendLoginEvent({ User_id: ssoCustomerNo, Channel: "web" });
        } else if (isWebView) {
          console.log("[GA LOGIN] WebViewなのでWeb側は送信しない");
        }

        // 利用可能補助金の取得
        // const params = {}
        // const subsidy = await this.$repositories(
        //   'subsidy'
        // ).getSubsidyAvailableLogin(params)
        // this.$store.commit('subsidy/setSubsidy', subsidy.data)
        // this.$store.commit('subsidy/remove')
        // this.$store.dispatch('subsidy/getSubsidy')
        this.$loading.hide()

        // ↓↓↓↓個人課金対応↓↓↓↓
        //支払方法設定要否判断API
        const mustHavePayment = await this.$repositories("stay").getMustHavePaymentCheck().catch(
          (e) => {
            console.log("支払方法設定要否判断APIエラー");
            console.log(e);
            if (e.data && e.data.statusCode == 400 && (e.data.error == "E-0101" || e.data.error == "E-0102")) {
              //個人課金対象外の場合、個人課金対象外であることを、storeに保存
              console.log("個人課金対象外エラー");
              this.$store.commit("personalPayment/setPersonalPaymentTarget", false);
            } else {
              console.log("個人課金対象外エラー以外のエラー");
              throw e;
            }
          }
        );
        if(mustHavePayment && mustHavePayment.status == 200){//個人課金対象の場合
          this.$store.commit("personalPayment/setMustHavePayment",
            mustHavePayment.data.isSetUpPaymentMethod);//個人課金対象判断情報をstoreに保存
          this.$store.commit("personalPayment/setPersonalPaymentTarget", true);//個人課金対象であることを、storeに保存
          //支払方法設定必要がある場合、支払方法設定画面に遷移
          if(mustHavePayment.data.isSetUpPaymentMethod){
            window.location.href = process.env.VUE_APP_TOP_DOMAIN + "/select-payment";
            return;
          }
        }
        // else if(mustHavePayment.status == 400 && (mustHavePayment.error == "E-0101" || mustHavePayment.error == "E-0102")){
        //   //個人課金対象外の場合、個人課金対象外であることを、storeに保存
        //   this.$store.commit("personalPayment/setPersonalPaymentTarget", false);
        // }
        // ↑↑↑↑個人課金対応↑↑↑↑

        // const backUri = this.backUri ? this.backUri : '/'
        const backUri = this.getCurrentHref()
        this.gotoBackURI(backUri)
        // location.href = backUri
        // this.$router.push({
        //   path: backUri
        // })
      }
    },
    hide() {
      // 戻り先用のクッキー削除
      document.cookie = createSetCookie('back_uri', '', new Date(0))
      this.deleteUserCookie()
      this.$auth.remove()
      this.$loading.hide()
      // const backUri = this.backUri ? this.backUri : '/'
      const backUri = this.getCurrentHref()
      this.gotoBackURI(backUri)
      // location.href = backUri
      // this.$router.push({
      //   path: backUri
      // })
      console.log('hide: backUri >>> ', backUri)
    },
    // ログイン関連のcookieを全部消す。失敗した時用。
    /**
     * 通常のaxiosアクセスをラップ
     * ※非同期をpromise型で返却するよう処理
     */
    async axiosPostWrap(url, params, credentials) {
      return await (() => new Promise((resolve) => {
        this.$axios
          .post(url, params, {
            headers: {
              'Authorization': `Basic ${credentials}`,
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then((res) => {
            // this.$axios.get(url).then((res) => {
            resolve(res)
          })
          .catch((error) => {
            resolve({
              ...error,
              isError: true
            })
          })
      }))()
    },
    setUserCookie(name, val) {
      document.cookie = createSetCookie(name, val)
    },
    deleteUserCookie() {
      document.cookie = createSetCookie('userInfo', '', new Date(0))
    },
    deleteLoginCookie() {
      this.deleteUserCookie()
      document.cookie = createSetCookie('idToken', '', new Date(0))
      document.cookie = createSetCookie('access_token', '', new Date(0))
      document.cookie = createSetCookie('refresh_token', '', new Date(0))
      document.cookie = createSetCookie('sub', '', new Date(0))
      document.cookie = createSetCookie('iss', '', new Date(0))
    },
    handleErrorPattern(errorPatternCode, errorCode, startDate) {
      // エラーパターンに応じた処理を関数内で分岐
      switch (errorPatternCode) {
        case 'BS-CONTRACT-0002':
          this.$store.commit('authError/reset');
          this.$store.commit('authError/data', { startDate });

          this.$router.push({
            name: 'error-contract-0002',
          });
          console.log('loginエラー:入会日前の会員');
          break;

        case 'BS-CONTRACT-0003':
          this.$router.push({
            name: 'error-contract-0003',
          });
          console.log('loginエラー:退会済の会員・法人の会員');
          break;

        case 'BS-CONTRACT-0004':
          this.$router.push({
            name: 'error-contract-0004',
          });
          console.log('loginエラー:福利BS（各サイト）契約外会員');
          break;

        case 'BS-CONTRACT-0006':
          this.$store.commit('authError/reset');
          this.$store.commit('authError/data', { errorCode });

          this.$router.push({
            name: 'error-contract-0006',
          });
          console.log('loginエラー:判別できないエラー');
          break;

        case 'BS-CONTRACT-0008':
          this.$router.push({
            name: 'error-contract-0008',
          });
          console.log('loginエラー:CRM会員');
          break;

        case 'BS-CONTRACT-0009':
        this.$router.push({
          name: 'error-contract-0009',
        });
        console.log('loginエラー:Dummy Account');
        break;

        default:
          this.$router.push('error');
          console.warn('未知のエラーパターンコード:', errorPatternCode);
          break;
      }
    },
  }
}
</script>
